import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'district-pm',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex-align-items-center justify-content-center">
      <span class="text-details" (click)="onCellClick(true)">
        {{ rowData.district }}
      </span>
    </div>
  `,
  styles: [
    `
      .text-details {
        font-family: var(--manrope);
        font-size: 16px;
        font-weight: 500;
        line-height: 21.86px;
        color: var(--brand-primary);
        cursor: pointer;
      }
    `,
  ],
})
export class DistrictPMCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<{ district: string; clicked: boolean }> =
    new EventEmitter<{ district: string; clicked: boolean }>();
  onCellClick(clicked: boolean) {
    this.cellClick.emit({ district: this.rowData.district, clicked });
  }
}
